<script>
import { get_currency, get_decimal } from "../../../Helper/helper";
import config from "../../../config";
export default {
  props: ["order", "loading","amounts"],
  data() {
    return {
      currency: get_currency(),
      decimal: get_decimal(),
      config: config,
    };
  },
  methods: {
    btoa(str) {
      return btoa(str);
    },
    germanDecimalNumber(number) {
    
    return parseFloat(number).toFixed(2).replace('.', ',');
    },
    singleBottleQty(single_bottle_qty) {
      return single_bottle_qty > 0 ? single_bottle_qty : 0;
    },
    missingQty(single_bottle_qty) {
      return single_bottle_qty <= 0 ? single_bottle_qty : 0;
    },
    // hasDeposits() {
    //   return this.order && this.order.depostis && this.order.depostis.Result && Array.isArray(this.order.depostis.Result.deposits) && this.order.depostis.Result.deposits.length > 0;
    // }
  },
};
</script>

<template>
  <!-- View Detail Main Start -->
  <div class="row mt-3 settings-main">
    <div class="col-12">
      <div class="text-center text-danger my-2" v-if="loading">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
      </div>
    </div>
    <div class="col-md-12" v-if="!loading">
      <div class="row">
        <div class="col-md-4" v-if="!$auth.partner_login">
          <h6>
            {{
              trans.get("__JSON__.Vendor's Name", {
                vendor: $auth.getRestaurantName(),
              })
            }}
          </h6>
          <p>
            <b-link
              :to="{
                name: 'vendor-detail',
                params: { restaurant_id: btoa(order.restaurant.restaurant_id) },
              }"
              >{{ order.restaurant.name }}</b-link
            >
          </p>
        </div>
        <div class="col-md-4" v-else>
          <h6>
            {{
              trans.get("__JSON__.Vendor's Name", {
                vendor: $auth.getRestaurantName(),
              })
            }}
          </h6>
          <p>{{ order.restaurant.name }}</p>
        </div>
        <div class="col-md-4" v-if="!$auth.partner_login">
          <h6>{{ trans.get("__JSON__.Customer's Name") }}</h6>
          <p>
            <b-link
              :to="{
                name: 'customer-detail',
                params: { user_id: btoa(order.user.user_id) },
              }"
              >{{ order.user.user_name + " " + order.user.last_name }}</b-link
            >  {{ order.ship_address && order.ship_address.company_name ? ', ' + order.ship_address.company_name : '' }}
          </p>
        </div>
        <div class="col-md-4" v-else>
          <h6>{{ trans.get("__JSON__.Customer's Name") }}</h6>
          <p>{{ order.user.user_name + " " + order.user.last_name }}
            {{ order.ship_address && order.ship_address.company_name ? ', ' + order.ship_address.company_name : '' }}
          </p>
        </div>
        <div class="col-md-4" v-if="!$auth.partner_login && order.delivery_type == '1'">
          <h6>
            {{
              trans.get("__JSON__.Driver Name", {
                driver: $auth.getDriverName(),
              })
            }}
          </h6>
          <p v-if="order.driver.length > 0">
            <b-link
              :to="{
                name: 'driver-details',
                params: { driver_id: btoa(order.driver[0].driverid) },
              }"
            >
              {{
                order.driver.length > 0
                  ? order.driver[0].firstname + " " + order.driver[0].lastname
                  : "-"
              }}</b-link
            >
          </p>
          <p v-else>-</p>
        </div>
        <div class="col-md-4" v-else-if="order.delivery_type == '1'">
          <h6>
            {{
              trans.get("__JSON__.Driver Name", {
                driver: $auth.getDriverName(),
              })
            }}
          </h6>
          <p>
            {{
              (order.driver.length > 0)
                ? order.driver[0].firstname + " " + order.driver[0].lastname
                : "-"
            }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-12" v-if="!loading">
      <div class="row sections-main">
        <div class="col-md-4">
          <h6>
            {{
              trans.get("__JSON__.Merchant Phone", {
                vendor: $auth.getRestaurantName(),
              })
            }}
          </h6>
          <p>{{ order.restaurant.phone }}</p>
        </div>
        <div class="col-md-4">
          <h6>{{ trans.get("__JSON__.Customer's Phone") }}</h6>
          <p>{{ (order.ship_address.phone != null)?order.ship_address.phone:'-' }}</p>
        </div>
        <div class="col-md-4" v-if="order.delivery_type == '1'">
          <h6>
            {{
              trans.get("__JSON__.Driver Phone", {
                driver: $auth.getDriverName(),
              })
            }}
          </h6>
          <p>
            {{
              (order.driver.length > 0)
                ? order.driver[0].country_code + " " + order.driver[0].contactno
                : "-"
            }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-12 mt-3" v-if="!loading">
      <div class="row sections-main">
        <div class="col-md-4" v-if="order.delivery_type == '0'">
          <h6>
            {{ trans.get("__JSON__.Pickup Location") }}
            <i class="bx bx-map bx-border"></i>
          </h6>
          <p>{{ order.restaurant.address }}</p>
        </div>
        <div class="col-md-4" v-if="order.ship_address != null && order.delivery_type == '1'">
          <h6>
            {{ trans.get("__JSON__.Drop Location") }}
            <i class="bx bx-map bx-border"></i>
          </h6>
          <p>
            <span class="font-weight-bold">{{
              trans.get("__JSON__.Address")
            }}</span
            >: {{ order.ship_address.street }}
            {{ order.ship_address.street_no }} {{ order.ship_address.postal_code }} {{ order.ship_address.city }}
          </p>
          <p>
            <span class="font-weight-bold">{{
              trans.get("__JSON__.Locality")
            }}</span
            >: {{ order.ship_address.city }}
          </p>
        </div>
        <div class="col-md-4">
          <h6>{{ trans.get("__JSON__.Payment Details") }}</h6>
          <p>
            <span class="text-success"
              >{{ parseFloat(order.total_amount || 0).toFixed(decimal) }}/{{
                order.payment_method.name
              }}</span
            >
            <span class="text-success" v-html="currency"></span>
            <template v-if="order.reddemed_coupon_order">
              <br />
              <span class="text-danger"
                >{{
                  parseFloat(
                    order.reddemed_coupon_order.discount_price || 0
                  ).toFixed(decimal)
                }}/{{ trans.get("__JSON__.Coupon Discount") }}</span
              >
              <span class="text-danger" v-html="currency"></span>
            </template>
          </p>
        </div>

        <div class="col-md-4">
          <h6>{{trans.get("__JSON__.Due Amount")}}</h6>
          <p>
          <span>{{ parseFloat(amounts.unpaid_amount || 0).toFixed(decimal) }}</span>
          <span v-html="currency"></span>
          </p>
        </div>

        <div class="col-md-4">
          <h6>{{trans.get("__JSON__.Paid Amount")}}</h6>
          <p>
          <span>{{ parseFloat(amounts.paid_amount || 0).toFixed(decimal) }}</span>
          <span v-html="currency"></span>
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-12 mt-3" v-if="!loading">
      <div class="row sections-main">
        <div class="col-md-6">
          <h6>{{ trans.get("__JSON__.Delivery date") }}</h6>
          <p>{{ order.delivery_date }}</p>
        </div>

        <div class="col-md-6">
          <h6>{{ trans.get("__JSON__.Time Slot") }}</h6>
          <p>{{order.delivery_from_time}}-{{order.delivery_to_time}}</p>
        </div>
      </div>
    </div>

    <div class="col-md-12 mt-3" v-if="!loading">
      <div class="row sections-main">
        <div
          class="col-md-4"
          v-if="
            order.created_date != '0000-00-00 00:00:00' &&
            order.order_status == 10
          "
        >
          <h6>{{ trans.get("__JSON__.Placement time") }}</h6>
          <p v-if="order.created_date != '0000-00-00 00:00:00'">
            {{ order.created_date }}
          </p>
        </div>
        <div
          class="col-md-4"
          v-if="
            order.ready_to_collect_date != '0000-00-00 00:00:00' &&
            order.ready_to_collect_date != null &&
            order.delivery_type == '0'
          "
        >
          <h6>{{ trans.get("__JSON__.Ready To Collect Time") }}</h6>
          <p>{{ order.ready_to_collect_date }}</p>
        </div>
        <div
          class="col-md-4"
          v-if="
            order.confirm_date != '0000-00-00 00:00:00' &&
            order.order_status == 13
          "
        >
          <h6>{{ trans.get("__JSON__.Accepted Time") }}</h6>
          <p v-if="order.confirm_date != '0000-00-00 00:00:00'">
            {{ order.confirm_date }}
          </p>
        </div>
        <div
          class="col-md-4"
          v-if="
            order.readytoserve_date != '0000-00-00 00:00:00' &&
            order.order_status == 5
          "
        >
          <h6>{{ trans.get("__JSON__.Ready To Serve time") }}</h6>
          <p v-if="order.readytoserve_date != '0000-00-00 00:00:00'">
            {{ order.readytoserve_at }}
          </p>
        </div>
        <div
          class="col-md-4"
          v-if="
            order.ontheway_date != '0000-00-00 00:00:00' &&
            order.order_status == 6
          "
        >
          <h6>{{ trans.get("__JSON__.Picked up Time") }}</h6>
          <p>{{ order.ontheway_date }}</p>
        </div>
        <div
          class="col-md-4"
          v-if="
            order.delivered_date != '0000-00-00 00:00:00' &&
            order.order_status == 7
          "
        >
          <h6>{{ trans.get("__JSON__.Delivered time") }}</h6>
          <p>{{ order.delivered_date }}</p>
        </div>
        <div class="col-md-4" v-if="order.order_status == 14">
          <h6>{{ trans.get("__JSON__.Cancelled time") }}</h6>
          <!-- <p>{{ order.order_date }}</p> -->
          <p>{{this.moment(order.cancelled_date).format('YYYY-MM-DD')}}</p>
          <!-- <span v-b-popover.hover.top="order.cancelled_desc" :title="trans.get('__JSON__.Cancel Description')" class="font-size-15"><i class="bx bx-info-circle"></i></span> -->
        </div>
        <div class="col-md-4" v-if="order.order_status == 14">
          <h6>{{ trans.get("__JSON__.Cancel Description") }}</h6>
          <p>{{ order.cancelled_desc }}</p>
        </div>
      </div>
    </div>

    <!-- <div class="col-md-12" v-if="!loading">
        <div class="row sections-main">
        </div>
      </div> -->

    <div class="col-md-12 mt-3" v-if="!loading">
      <div class="row sections-main">
        <div
          class="col-md-4"
          v-if="order.distance_km && order.distance_km != ''"
        >
          <h6>{{ trans.get("__JSON__.Distance In KM") }}</h6>
          <p>{{ order.distance_km }}</p>
        </div>
        <div
          class="col-md-4"
          v-if="order.distance_mintue && order.distance_mintue != ''"
        >
          <h6>{{ trans.get("__JSON__.Distance In Minute") }}</h6>
          <p>{{ order.distance_mintue }}</p>
        </div>
        <div class="col-md-4" v-if="!$auth.partner_login && order.delivery_type=='1'">
          <h6>{{ trans.get("__JSON__.Last Mile Earning") }}</h6>
          <p>
            {{ parseFloat(order.driver_earning || 0).toFixed(decimal) }}
            <span v-html="currency"></span>
          </p>
        </div>
        <div class="col-md-4" v-if="!$auth.partner_login">
          <h6>{{ trans.get("__JSON__.Admin Earning") }}</h6>
          <p>
            {{ parseFloat(order.admin_commision || 0).toFixed(decimal) }}
            <span v-html="currency"></span>
          </p>
        </div>
        <div class="col-md-4" v-if="!$auth.partner_login && order.delivery_type=='1'">
          <h6>{{ trans.get("__JSON__.Delivery Charge") }}</h6>
          <p>
            {{ parseFloat(order.delivery_fee || 0).toFixed(decimal) }}
            <span v-html="currency"></span>
          </p>
        </div>
        <div class="col-md-4">
          <h6>{{ trans.get("__JSON__.Notes") }}</h6>
          <p>{{ order.suggestion }}</p>
        </div>
      </div>
    </div>

    <div class="col-md-12 mt-3" v-if="!loading">
      <div class="row sections-main">
        <div class="col-md-4" v-if="!$auth.partner_login">
          <h6>{{ trans.get("__JSON__.Device Type") }}</h6>
          <!-- <p>{{ order.device_type + ' ' + order.app_version_code }}</p> -->
          <p>{{ order.device_type }}</p>
        </div>

        <div class="col-md-4" v-if="order.signature_img">
          <h6>{{ trans.get("__JSON__.Signature Image") }}</h6>
          <img
            alt
            title="signature-img"
            class="vendor-img"
            :src="config.signatureImage + order.signature_img"
          />
        </div>
      </div>
    </div>
    <div class="col-md-12 mt-3" v-if="!loading && order.depostis.Result.deposits != undefined && order.depostis.Result.deposits.length !== 0">
      <div class="row sections-main">
            <div class="col-md-12" v-if="order.depostis.Result.deposits">
              <h6>Leergut</h6>
                <table style="text-align: center;">
                <thead>
                    <tr>
                        <th class="col-md-3"><h6>Product name</h6></th>
                        <th class="col-md-2"><h6>Quantity</h6></th>
                        <th class="col-md-3"><h6>Deposit bottles (€)</h6></th>
                        <th class="col-md-3"><h6>Deposit carrier (€)</h6></th>
                        <th class="col-md-3"><h6>single bottles</h6></th>
                        <th class="col-md-3"><h6>Missing bottles</h6></th>
                        <th class="col-md-3"><h6>Leergut</h6></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(depostis, index) in order.depostis.Result.deposits" :key="index">
                        <td> {{ depostis.box_title != '' ? depostis.box_title :'' }}  </td>
                        <td>{{ depostis.qty != '' ? depostis.qty : '/' }}</td>
                        <td>{{ depostis.sub_product_id !== '' && depostis.single_refund_price > 0 ? depostis.selling_qty + ' X ' + germanDecimalNumber(depostis.single_refund_price) +currency : '/' }}</td>
                        <td>{{ depostis.box_price >0 ? germanDecimalNumber(depostis.box_price) : '0,00' }} <span v-html="currency"></span></td>
                        <td>{{ singleBottleQty(depostis.single_bottle_qty) }}</td>
                        <td>{{ missingQty(depostis.single_bottle_qty) }} </td>
                        <td>{{  germanDecimalNumber(depostis.price) }}  <span v-html="currency"></span></td>
                    </tr>
                </tbody>
            </table>

            </div>
        </div>
    </div>

    <!-- View Detail Main End -->
  </div>
</template>
